import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAuth, inMemoryPersistence, onIdTokenChanged, setPersistence, signInWithEmailAndPassword, signOut, } from 'firebase/auth';
import { FIREBASE_API_KEY, FIREBASE_APP_ID, FIREBASE_AUTH_DOMAIN, FIREBASE_MESSAGING_SENDER_ID, FIREBASE_PROJECT_ID, FIREBASE_STORAGE_BUCKET, } from './constants';
const app = getApps().length
    ? getApp()
    : initializeApp({
        apiKey: FIREBASE_API_KEY,
        authDomain: FIREBASE_AUTH_DOMAIN,
        projectId: FIREBASE_PROJECT_ID,
        appId: FIREBASE_APP_ID,
        messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
        storageBucket: FIREBASE_STORAGE_BUCKET,
    });
const firebaseAuth = getAuth(app);
void setPersistence(firebaseAuth, inMemoryPersistence).catch(() => undefined);
let current = null;
const listeners = new Set();
function emit() {
    for (const listener of listeners)
        listener(current);
}
onIdTokenChanged(firebaseAuth, (user) => {
    void (async () => {
        if (!user || !user.email) {
            current = null;
            emit();
            return;
        }
        current = {
            accessToken: await user.getIdToken(),
            sub: user.uid,
            name: user.displayName ?? user.email,
            email: user.email,
            tier: current?.tier ?? 'free',
        };
        emit();
    })();
});
export function isAuthenticated() {
    return firebaseAuth.currentUser !== null;
}
export async function getAccessToken() {
    const user = firebaseAuth.currentUser;
    if (!user)
        return null;
    const accessToken = await user.getIdToken();
    if (current)
        current = { ...current, accessToken };
    return accessToken;
}
export function getUser() {
    if (!current)
        return null;
    const { accessToken: _accessToken, ...user } = current;
    return user;
}
export function onAuthChange(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
export async function login(email, password) {
    const credential = await signInWithEmailAndPassword(firebaseAuth, email, password);
    const user = credential.user;
    if (!user.email)
        throw new Error('This Firebase account has no email address.');
    current = {
        accessToken: await user.getIdToken(),
        sub: user.uid,
        name: user.displayName ?? user.email,
        email: user.email,
        tier: 'free',
    };
    emit();
    return current;
}
export function logout() {
    current = null;
    emit();
    void signOut(firebaseAuth);
}
